// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__2R-7c","fileBtn":"File_fileBtn__2veVL","closeBtn":"File_closeBtn__8quSQ","fileSelected":"File_fileSelected__22z-K","disabled":"File_disabled__7F1_q"};